import React from 'react';

export interface IProps {
  fillColor?: string;
}

const AlertIcon:React.FC<IProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 17 17">
      <circle cx="8.5" cy="8.5" r="8.5" fill={props.fillColor ?? "#FF7319"}/>
      <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 4.535v4.967"/>
      <circle cx="8.5" cy="12.278" r=".567" fill="#fff" stroke="#fff"/>
    </svg>
  )
}

export default AlertIcon;